import { useRouter } from "next/router";
import { useMediaQuery } from "@mantine/hooks";
import useListings from "../../hooks/useListings";
import Head from "next/head";
import { NextSeo } from "next-seo";
import { Header } from "../../components/headers/Header";
import MobileFilter from "../../components/sidebar/MobileFilter";
import TotalListingsTitle from "../../components/titles/TotalListingsTitle";
import OverviewLoader from "../../components/loaders/OverviewLoader";
import AccommodationsList from "../../components/lists/AccommodationList";
import OverviewPagination from "../../components/pagination/OverviewPagination";
import { Col, Grid } from "@mantine/core";
import SidebarFilter from "../../components/sidebar/SidebarFilter";
import Footer from "../../components/footer/Footer";

const title = "Vakantiehuis zoeken en online boeken | TopVakantiehuizen.eu";
const description =
  "Boek je vakantie veilig & snel op TopVakantiehuizen.eu! Bij TopVakantiehuizen.eu vind je vakantiehuizen binnen en buiten Europa verdeeld over meer dan 18 landen.";

const ListingOverview = () => {
  const router = useRouter();
  const isMobile = useMediaQuery("(max-width: 992px)");
  const {
    listingResults,
    totalListings,
    countFilterResults,
    isLoading,
    isError,
  } = useListings({
    query: router.query,
  });

  return (
    <>
      <Head>
        <meta name="robots" content="all" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, shrink-to-fit=no"
        />
      </Head>
      <NextSeo
        title={title}
        description={description}
        canonical={`https://www.topvakantiehuizen.eu/vakantiehuizen`}
        openGraph={{
          title: "Vakantiehuis zoeken en online boeken | TopVakantiehuizen.eu",
          description,
          url: `https://www.topvakantiehuizen.eu/vakantiehuizen`,
          images: [
            {
              url: "https://www.topvakantiehuizen.eu/assets/logo/TopVakantiehuizen.eu.png",
              width: 1324,
              height: 927,
              alt: "Logo van TopVakantiehuizen.eu",
              type: "image/png",
            },
          ],
          site_name: "TopVakantiehuizen.eu",
        }}
        twitter={{
          handle: "@handle",
          site: "@site",
          cardType: "summary_large_image",
        }}
      />
      <Header />
      <main id="content">
        <div className="pt-lg-8 container pt-3">
          <div className="mb-lg-8 mt-xl-1 mb-5">
            {!isError ? (
              <>
                {isMobile && (
                  <>
                    <MobileFilter
                      countFilterResults={countFilterResults}
                      totalListings={totalListings}
                    />
                    <TotalListingsTitle
                      isLoading={isLoading}
                      total={totalListings}
                    />
                    <OverviewLoader isLoading={isLoading} />
                    <AccommodationsList
                      isLoading={isLoading}
                      listingResults={listingResults}
                    />
                    <OverviewPagination
                      isLoading={isLoading}
                      totalResults={listingResults?.total}
                    />
                  </>
                )}

                {!isMobile && (
                  <Grid columns={24}>
                    <Col span={24} md={9} lg={7}>
                      <SidebarFilter countFilterResults={countFilterResults} />
                    </Col>
                    <Col
                      span={24}
                      md={15}
                      lg={17}
                      style={{ position: "relative" }}
                    >
                      <TotalListingsTitle
                        isLoading={isLoading}
                        total={totalListings}
                      />
                      <OverviewLoader isLoading={isLoading} />
                      <AccommodationsList
                        isLoading={isLoading}
                        listingResults={listingResults}
                      />
                      <OverviewPagination
                        isLoading={isLoading}
                        totalResults={listingResults?.total}
                      />
                    </Col>
                  </Grid>
                )}
              </>
            ) : (
              <p>Er is iets fout gegaan aan onze kant...</p>
            )}
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default ListingOverview;
